/**
 * CRC-32/IEEE, the checksum every zip entry carries.
 *
 * Present because a backup file is the only copy of photos that no longer
 * exist anywhere else. A truncated download or a half-written file should say
 * so on restore rather than quietly producing an item with a broken photo.
 */

const TABLE = buildTable();

/** Feed chunks in order; `seed` is the previous return value. */
export function crc32(bytes: Uint8Array, seed = 0): number {
  let crc = ~seed;

  for (let i = 0; i < bytes.length; i += 1) {
    // Both indexes are masked to a byte, so neither can miss the table.
    const byte = bytes[i] as number;
    crc = (TABLE[(crc ^ byte) & 0xff] as number) ^ (crc >>> 8);
  }

  return ~crc >>> 0;
}

function buildTable(): Uint32Array {
  const table = new Uint32Array(256);

  for (let n = 0; n < 256; n += 1) {
    let c = n;
    for (let bit = 0; bit < 8; bit += 1) {
      c = (c & 1) === 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    }
    table[n] = c >>> 0;
  }

  return table;
}
